module.exports = __webpack_public_path__ + "static/img/shuzhi.d1ff0399.png";